import styled from '@emotion/styled/macro';
import PropTypes from 'prop-types';
import { Tabs } from '../../containers/tabs';
import { fonts } from '../../styles/theme';
import { Textarea } from './Input';
import Mentions from './Mentions';
import { withoutReplyFormStyle } from '../../styles/mentionInputStyle';

const { Tab, TabsContainer, TabList, TabPanel } = Tabs;

// eng-maintenance#21234 — the migration collapsed this component to a bare textarea, dropping the
// "Write | Guide" tab structure it shipped in @contently/toolkit@3.17.2 (the version classic ran).
// Restored to exact parity: a Write pane (mention-aware textarea, or plain when `outdated`) plus a
// static markdown Guide tab. Verbatim guide content from the original toolkit component.

const MarkdownGuideWrapper = styled('div')`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  font-size: ${fonts.sans.size.small};
  line-height: 20px;
`;

const MarkdownGuideColumn = styled('div')`
  white-space: nowrap;
  padding-right: 15px;
`;

const SubItem = styled('div')`
  line-height: 18px;
`;

const MarkdownGuideItem = styled('div')``;

const MarkdownGuide = () => (
  <MarkdownGuideWrapper>
    <MarkdownGuideColumn>
      <MarkdownGuideItem>**This will be bold**</MarkdownGuideItem>
      <MarkdownGuideItem>_This will be italic_</MarkdownGuideItem>
      <MarkdownGuideItem>~~strikethrough~~</MarkdownGuideItem>
    </MarkdownGuideColumn>

    <MarkdownGuideColumn>
      <MarkdownGuideItem>&gt; Block quote</MarkdownGuideItem>
      <MarkdownGuideItem>- [ ] Checkbox</MarkdownGuideItem>
      <MarkdownGuideItem>- [x] Checkbox</MarkdownGuideItem>
    </MarkdownGuideColumn>

    <MarkdownGuideColumn>
      <MarkdownGuideItem>- Bulleted list</MarkdownGuideItem>
      <SubItem>&nbsp;&nbsp;&nbsp;- sub item</SubItem>
      <SubItem>&nbsp;&nbsp;&nbsp;- sub item</SubItem>
    </MarkdownGuideColumn>

    <MarkdownGuideColumn>
      <MarkdownGuideItem>1. Numbered list</MarkdownGuideItem>
      <SubItem>&nbsp;&nbsp;&nbsp;1. sub item</SubItem>
      <SubItem>&nbsp;&nbsp;&nbsp;2. sub item</SubItem>
    </MarkdownGuideColumn>
  </MarkdownGuideWrapper>
);

const ResizeWrapper = styled('div')`
  textarea {
    ${(props) => (props.resize === false ? 'resize: none;' : null)}
  }
`;

export const MarkdownPreviewTextarea = (props) => {
  const { name, resize, outdated, onMentionAdd } = props;

  return (
    <TabsContainer>
      <TabList>
        <Tab>Write</Tab>
        <Tab className="react-tabs__tab-guide">Guide</Tab>
      </TabList>
      <TabPanel>
        <ResizeWrapper resize={resize}>
          {outdated ? (
            <Textarea autoFocus {...props} id={name} />
          ) : (
            <Mentions autoFocus {...props} style={withoutReplyFormStyle} onMentionAdd={onMentionAdd} />
          )}
        </ResizeWrapper>
      </TabPanel>
      <TabPanel className="react-tabs__tab-panel-guide">
        <MarkdownGuide />
      </TabPanel>
    </TabsContainer>
  );
};

const userShape = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  display: PropTypes.string.isRequired,
  avatar: PropTypes.string.isRequired,
};

MarkdownPreviewTextarea.propTypes = {
  value: PropTypes.string,
  users: PropTypes.arrayOf(PropTypes.shape(userShape)),
  rows: PropTypes.number,
  name: PropTypes.string,
  resize: PropTypes.bool,
  outdated: PropTypes.bool,
  onChange: PropTypes.func,
  onMentionAdd: PropTypes.func,
};

MarkdownPreviewTextarea.defaultProps = {
  value: '',
  rows: 7,
  users: [],
  onChange: () => {},
  name: '',
  resize: true,
  outdated: false,
};
